export default __webpack_public_path__ + "static/banner-underwater-hotels-04d95d0eac33304253335c2b6e9b4dea.jpg";